module.exports = __webpack_public_path__ + "img/dostosuj_tabele.511b8b05.svg";